import { useEffect } from 'react';

import validate from './RefundToolSearchFormValidation';

import UseForm from "@usas/ui-web/utils/UseForm";

const INITIAL_FORM_STATE = {
  receiptNumber: ''
};

const useRefundToolSearchForm = (onSubmitFormCallback, onClearSearchClicked) => {
  const { formState, errorState, isDirty, setFormState, updateFormState, setIsDirty, handleSubmit
  } = UseForm(INITIAL_FORM_STATE, onSubmitFormCallback, validate);

  const onClearClicked = () => {
    setFormState(INITIAL_FORM_STATE);

    onClearSearchClicked();
  };

  useEffect(() => {
    if (isDirty !== true) {
      setIsDirty(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDirty]);

  return {
    formState,
    errorState,
    updateFormState,
    onClearClicked,
    handleSubmit
  };
};

export default useRefundToolSearchForm;